import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router';
import { Box, Typography, Skeleton, IconButton, Stack } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useAuth } from '../../../../auth';
import { useFindSignatureBatchById } from '../../../../api/documentos/endpoints';

export const Route = createFileRoute('/__auth/signatures/$id')({
    component: SignatureDetailLayout,
});

function SignatureDetailLayout() {
    const { id } = Route.useParams();
    const { user } = useAuth();
    const router = useRouter();
    const tenant = user?.tenant || "default-domain";

    const { data: envelopeData, isLoading, error } = useFindSignatureBatchById(tenant, id!);

    if (isLoading) {
        return (
            <Box p={3}>
                <Skeleton variant="text" width="60%" height={40} />
                <Skeleton variant="rectangular" width="100%" height={200} sx={{ mt: 2 }} />
            </Box>
        );
    }

    if (error || !envelopeData) {
        return (
            <Box p={3}>
                <Typography color="error">Erro ao carregar detalhes do envelope.</Typography>
            </Box>
        );
    }

    // @ts-ignore - Temporary cast to bypass strict types on CoverDto title missing (it actually exists on API)
    const title = envelopeData?.title;

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, pt: 2, pb: 2, bgcolor: 'background.paper' }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <IconButton onClick={() => router.history.back()} color="primary" size="small" aria-label="voltar">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h5" fontWeight={600}>
                        {title || `Envelope #${id}`}
                    </Typography>
                </Stack>
            </Box>
            <Box sx={{ flex: 1, overflow: 'auto', p: 3, bgcolor: 'background.default' }}>
                <Outlet />
            </Box>
        </Box>
    );
}
